var map = {
	"./01.svg": 8236,
	"./02.svg": 9935,
	"./03.svg": 8045,
	"./04.svg": 4168,
	"./05.svg": 6765,
	"./06.svg": 4667,
	"./07.svg": 4420,
	"./08.svg": 5857,
	"./09.svg": 6706,
	"./10.svg": 9266,
	"./11.svg": 6821,
	"./12.svg": 3165,
	"./13.svg": 3765,
	"./14.svg": 6864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5391;